import React from 'react';
import { Cell, ColumnInterface } from 'react-table';
import { Tooltip } from '@trqk/components';

import { rowHeight } from '../constants';
import iconUrl from '../../../../../../assets/svg/insights-empty-gap-analysis.svg';
import { useGapAnalysisTools } from '../../../../../../hooks';

interface ReportNameCellProps {
    cell: Cell<TrqkGapSummary, GapSummaryReportNameCellValue>;
    column: ColumnInterface<TrqkGapSummary>;
}

const iconWidth = 24;

/**
 * Displays a report name in the GapAnalysisReportSummaryTable.
 * @param props - {@link ReportNameCellProps}
 * @returns JSX
 */
export function ReportNameCell({
    cell,
    column,
}: ReportNameCellProps): JSX.Element {
    const { openManageGapAnalysis } = useGapAnalysisTools();
    const width = (column?.width as number) ?? 100;
    const finalWidth = width - iconWidth - 10;
    const {
        value: { description, gapAnalysisId },
    } = cell;

    return (
        <Tooltip
            message={description}
            position="right"
            minWidth={250}
            maxWidth={250}
        >
            <div className="flex items-center" style={{ height: rowHeight }}>
                <img src={iconUrl} width={iconWidth} alt="Gap Analysis icon" />
                <button
                    type="button"
                    className="ml-2 respond-to-mouse"
                    style={{
                        width: finalWidth,
                    }}
                    onClick={() => {
                        openManageGapAnalysis({ gapAnalysisId, mode: 'edit' });
                    }}
                >
                    <p className="leading-tight clamp-2-lines-break-words underline text-left">
                        {description}
                    </p>
                </button>
            </div>
        </Tooltip>
    );
}
